import type { FilterItem } from '@ctw/shared/components/filter-bar/filter-bar-types';
import { dismissFilter } from '../../resource/filters';

export function allergyFilter(): Array<FilterItem> {
  return [dismissFilter];
}
